import * as THREE from "three";
import Experience from "./Experience";
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
import { GammaCorrectionShader } from "three/examples/jsm/shaders/GammaCorrectionShader";

export default class Renderer {
  constructor() {
    this.experience = new Experience();

    this.sizes = this.experience.size;
    this.canvas = this.experience.canvas;
    this.scene = this.experience.scene;
    this.mobileSize = this.experience.size.mobileSize;
    this.camera = this.experience.camera.instance;
    this.controls = this.experience.camera.controls;

    this.world = this.experience.world;
    //? form from html
    this.setUpRenderer();

    if (!this.mobileSize) {
      //? composer
      this.composer = new EffectComposer(this.renderer);
      this.composer.setPixelRatio(this.sizes.pixelRatio);

      //?render pass
      this.renderPass = new RenderPass(this.scene, this.camera);
      this.composer.addPass(this.renderPass);

      //? outline pass
      this.outlinePass = new OutlinePass(
        new THREE.Vector2(this.sizes.width, this.sizes.height),
        this.scene,
        this.camera
      );
      this.outlinePass.edgeStrength = 4.0;
      this.outlinePass.edgeGlow = 1.25;
      this.outlinePass.edgeThickness = 0.01;
      this.outlinePass.pulsePeriod = 1;
      this.outlinePass.usePatternTexture = false;
      this.outlinePass.visibleEdgeColor.set("#ffffff");
      this.outlinePass.hiddenEdgeColor.set("#ffffff");

      this.composer.addPass(this.outlinePass);

      //? fix textures shader

      this.gammaCorrectionPass = new ShaderPass(GammaCorrectionShader);
      this.composer.addPass(this.gammaCorrectionPass);
    }

    this.rayCaster = new THREE.Raycaster();
    this.pointer = new THREE.Vector2();

    this.intersectObjects = [];
    this.currentIntersects = null;

    window.addEventListener("mousemove", (event) => {
      this.pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    });

    this.setDebugger();

    //? after resources are ready
    this.experience.resources.on("resourcesReady", () => {
      this.intersectObjects = this.experience.world.intersectObjects;
      this.outlineStartObjects = this.experience.world.outlineStartObjects;

      if (!this.mobileSize) {
        this.outlinePass.selectedObjects = this.outlineStartObjects;
      }
    });
  }

  setUpRenderer() {
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      logarithmicDepthBuffer: true,
    });

    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(this.sizes.pixelRatio);
    this.renderer.setClearColor(0xffd700);

    this.renderer.outputColorSpace = THREE.SRGBColorSpace;
  }

  resize() {
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(this.sizes.pixelRatio);
  }

  setDebugger() {
    if (this.experience.debug.active) {
      this.rendererDebug =
        this.experience.debug.gui.addFolder("renderer-Debug");

      this.rendererDebug
        .add(this.renderer, "toneMappingExposure")
        .min(0)
        .max(10)
        .step(0.05)
        .onChange(() => {});

      this.rendererDebug.add(this.renderer, "toneMapping", {
        NoToneMapping: THREE.NoToneMapping,
        Reinhard: THREE.ReinhardToneMapping,
        Cineon: THREE.CineonToneMapping,
        Linear: THREE.LinearToneMapping,
      });
    }
  }

  update() {
    if (this.renderer) {
      this.renderer.render(this.scene, this.camera);
    }
  }
}
